import React from 'react';
import { w as withProviders } from '../../../withProviders-l3mjYkR2.js';
import { N as Navigation } from '../../../Navigation-yXC39IfA.js';
import { C as ContactUsForm } from '../../../ContactUsForm-EJ9jibi5.js';
import 'react-i18next';
import 'notistack';
import '../../../context/index.js';
import 'next/router';
import '../../../Item-Z13RNFMm.js';
import 'next-i18next';
import '../../Link/index.js';
import '../../../index-2586sEvh.js';
import '../../../_commonjsHelpers-jjO7Zipk.js';
import 'next/link';
import '../../../paths-ZKN3m62_.js';
import '../../../language-BHHwgtQp.js';
import 'react-hook-form';
import '../../../utils/logger.js';
import '../../../utils/logToSlack.js';
import '../../../animations--PMkOS0j.js';
import '../../../index-RkBJ48Nr.js';
import 'cookies-next';
import '../../../breakpoints-X1SKRYyW.js';
import '../../../currency-_kacFJHO.js';
import '../../../payment-YC9H491Y.js';
import '../../../hooks/useCaptcha.js';
import '../../../storeSelectors/captcha.js';
import '../../../index-zNO-4REJ.js';
import 'i18next';
import '../../../index-V63xQvL7.js';
import '../../../hooks/useShowError.js';
import '../../../utils/error.js';
import '../../../serverErrors-_VHsjhgw.js';
import '../../../utils/logToRelic.js';
import '../../../hooks/useShowNotify.js';
import '../../../hooks/useWindowSize.js';
import 'lodash/get';
import '../../../product-_pRduMz7.js';
import '../../../helpers-kA_hdoOI.js';
import '../../../utils/product.js';
import '../../../cookies-l-jEMp6P.js';
import 'lodash';
import '../../../utils/captcha.js';
import '../../../requestsCollection-gritD79O.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../../services/auth/index.js';
import '../../../utils/cookies.js';
import '../../../utils/isBot.js';
import '../../../utils/currency.js';
import '../../../utils/fetchPolicyLookup.js';
import './ContactUsForm/form/index.js';
import 'yup';
import '@hookform/resolvers/yup';
import '../../../utils/validation.js';
import '../../../validation-AjMAVn7m.js';
import '../../Button/index.js';
import '../../CircularProgress/index.js';
import '../../ButtonGroup/index.js';
import '../../../Input-quQLghm0.js';
import '../../../Textarea-CrVLRrCI.js';
import '../../../Select-LSn3KQwG.js';
import '../../../HCaptcha-z_AMrNS9.js';
import '@hcaptcha/react-hcaptcha';
import '../../../GetHCaptchaToken-sJpm0bg0.js';
import '../../../services/graphql/help/index.js';

const ContactUs = ({ pageContent, disclaimerText, getLocalNavigationItems }) => (React.createElement("div", { className: "help-page" },
    React.createElement(Navigation, { getLocalNavigationItems: getLocalNavigationItems }),
    React.createElement("div", { className: "content faq" },
        pageContent && React.createElement("div", { dangerouslySetInnerHTML: { __html: pageContent } }),
        React.createElement(ContactUsForm, null),
        disclaimerText && React.createElement("div", { dangerouslySetInnerHTML: { __html: disclaimerText } }))));
var ContactUs$1 = withProviders(ContactUs, { translation: true, snackbar: true });

export { ContactUs$1 as default };
//# sourceMappingURL=index.js.map
